import React, { CSSProperties, useEffect } from 'react';
import { ButtonView } from '@vivli/shared/views';
import { Color, Size } from '@vivli/shared/theme';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IPageLink } from '@vivli/shared/infrastructure/interface';

interface DashboardHeaderViewProps {
    moreInformationUrl?: string;
    moreInformationDescription: string;
    handleExport?: () => void;
    currentLink?: IPageLink;
    showOrgButton?: boolean;
}

export const headerContainerStyle: CSSProperties = {
    display: 'grid',
    width: '100%',
    height: '100%',
    gridTemplateRows: 'auto auto auto',
    gridTemplateColumns: '70% 1fr',
    alignItems: 'start',
    backgroundColor: 'rgb(233, 234, 239)',
    paddingTop: Size.PADDING,
    paddingBottom: Size.PADDING,
    gap: '8px 0'
};

const titleStyle: CSSProperties = {
    fontSize: 30,
    fontWeight: '550',
    color: '#5F6C79', //color per figma
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'left'
};

const subTitleStyle: CSSProperties = {
    fontSize: '14px',
    color: '#5F6C79', //color per figma
    fontWeight: Size.FontWeight.Regular
};

export const DashboardHeaderView = ({
    moreInformationUrl,
    moreInformationDescription,
    handleExport,
    currentLink,
    showOrgButton
}: DashboardHeaderViewProps) => {
    const descriptionText = `Your dashboard is a consolidation of all the items within Vivli that require your action. Use the tabs to view your actions. For more information see the `;
    const orgButtonText = 'View My Organization + Roles';
    const [currentHasData, setCurrentHasData] = React.useState(true);

    function handleDownloadClick() {
        handleExport();
    }

    function handleOrgButtonClick() {
        window.open(`/admin/orgs`, '_blank');
    }

    useEffect(() => {
        if (currentLink === null || currentLink === undefined || currentLink.count === null || currentLink.count === undefined) {
            return;
        }
        const hasData = currentLink.count > 0;
        setCurrentHasData(hasData);
    }, [currentLink]);

    return (
        <div style={headerContainerStyle}>
            <div style={{ ...titleStyle, gridColumn: '1', gridRow: '1' }}>Vivli Dashboard</div>

            <div style={{ gridColumn: '2', gridRow: '1', justifySelf: 'end' }}>
                {showOrgButton && (
                    <ButtonView title={orgButtonText} theme={'white-on-lightblue'} onClick={handleOrgButtonClick}>
                        {orgButtonText}
                    </ButtonView>
                )}
            </div>

            <div style={{ gridColumn: '2', gridRow: '2', justifySelf: 'end' }}>
                {currentHasData && (
                    <ButtonView title={'Download'} onClick={handleDownloadClick} theme={'darkblue-on-white'}>
                        <span>
                            <FontAwesomeIcon icon={faDownload} style={{ paddingRight: 5 }} /> Download
                        </span>
                    </ButtonView>
                )}
            </div>

            <div style={{ gridColumn: '1', gridRow: '2' }} />

            <div style={{ ...subTitleStyle, gridColumn: '1', gridRow: '2 / 4' }}>
                {descriptionText}
                <a href={moreInformationUrl} target="_blank" rel="noopener noreferrer">
                    {moreInformationDescription}
                </a>
            </div>
        </div>
    );
};
